export default __webpack_public_path__ + "static/media/screen1.f27d1a0c.png";